export const WHEN_OPTIONS = [
  {
    key: 'outgoing',
    value: 'outgoing',
    text: 'Outgoing conversations',
    disabled: false,
  },
  {
    key: 'contacts',
    value: 'contacts',
    text: 'Contacts',
    disabled: false,
  },
  {
    key: 'incoming',
    value: 'incoming',
    text: 'Incoming conversations',
    disabled: false,
  },
]

export const IF_OPTIONS = [
  {
    value: 'mailboxId',
    key: 'mailboxId',
    text: 'Inbox',
    disabled: false,
  },
  {
    value: 'contactId',
    key: 'contactId',
    text: 'Sender Is',
    disabled: false,
  },
  {
    value: 'contactEmailDomain',
    key: 'contactEmailDomain',
    text: 'Contact Domain',
    disabled: false,
  },
  {
    value: 'subjectLike',
    key: 'subjectLike',
    text: 'Subject Contains',
    disabled: false,
  },
  {
    value: 'assigneeId',
    key: 'assigneeId',
    text: 'Assignee ',
    disabled: false,
  },
  {
    value: 'haveTags',
    key: 'haveTags',
    text: 'Have Tags',
    disabled: false,
  },
  {
    value: 'doNotHaveTags',
    key: 'doNotHaveTags',
    text: 'Do Not Have Tags',
    disabled: false,
  },
  {
    value: 'contactEmail',
    key: 'contactEmail',
    text: 'Contact Email',
    disabled: false,
  },
  {
    value: 'company',
    key: 'company',
    text: 'Company Name',
    disabled: false,
  },
]

export const THEN_OPTIONS = [
  {
    value: 'assigneeId',
    text: 'Assign To',
    action: 'ASSIGN_CONVERSATION',
    disabled: false,
  },
  {
    value: 'statusId',
    text: 'Set Status As',
    action: 'SET_STATUS',
    disabled: false,
  },
  {
    value: 'note',
    text: 'Add Notes',
    action: 'ADD_NOTE',
    disabled: false,
  },
  {
    value: 'addLabelIds',
    text: 'Add Tags',
    action: 'ADD_LABELS',
    disabled: false,
  },
  {
    value: 'removeLabelIds',
    text: 'Remove Tags',
    action: 'REMOVE_LABELS',
    disabled: false,
  },
  {
    value: 'mailboxId',
    text: 'Move To Inbox',
    action: 'MOVE_CONVERSATION',
    disabled: false,
  },
  {
    value: 'delete',
    text: 'Delete Conversation',
    action: 'DELETE_CONVERSATION',
    disabled: false,
  },
  {
    value: 'priority',
    text: 'Set Priority',
    action: 'SET_PRIORITY',
    disabled: false,
  },
]

export const IF_CONTACTS_OPTIONS = [
  // Create
  {value: 'firstName', text: 'First Name', key: 'firstName', disabled: false},
  {value: 'lastName', text: 'Last Name', key: 'lastName', disabled: false},
  {value: 'title', text: 'Title', key: 'title'},
  // {value: 'description', text: 'Description', key: 'description', disabled: false},
  {value: 'country', text: 'Country', key: 'country', disabled: false},
  // {value: 'assigneeId', text: 'Assignee', key: 'assigneeId', disabled: false},
  // {value: 'contactTypeId', text: 'Contact Type', key: 'contactTypeId', disabled: false},
  {value: 'labelIds', text: 'Label', key: 'labelIds', disabled: false},
  // update
  // {
  //   value: 'lastContacted',
  //   text: 'Last contacted',
  //   key: 'lastContacted',
  // disabled: false,
  // },
  {value: 'interactions', text: 'Interactions', key: 'interactions', disabled: false},
]

export const THEN_CONTACTS_OPTIONS = [
  // {value: 'website', text: 'Website', key: 'website', action: 'CONTACT_UPDATE', disabled: false},
  {value: 'companyId', text: 'Company', key: 'companyId', action: 'CONTACT_UPDATE', disabled: false},
  // {value: 'description', text: 'Description', key: 'description', action: 'CONTACT_UPDATE', disabled: false},
  {value: 'title', text: 'Title', key: 'title', action: 'CONTACT_UPDATE', disabled: false},
  {value: 'labelIds', text: 'Label', key: 'labelIds', action: 'CONTACT_UPDATE', disabled: false},
]
